import React, { FC } from 'react';
import { StyledDetails, StyledAspectRatio, StyledProductCardSkeleton } from './styled';
import { Skeleton } from '../Skeleton';

type ProductCardSkeletonProps = {
    shimmer?: boolean;
    fillHeight?: boolean;
    insideScroll?: boolean;
};

export const ProductCardSkeleton: FC<ProductCardSkeletonProps> = ({ shimmer, fillHeight, insideScroll }) => {
    return (
        <StyledProductCardSkeleton fillHeight={fillHeight}>
            <StyledAspectRatio ratio={1.49}>
                <Skeleton cover shimmer={shimmer} />
            </StyledAspectRatio>
            <StyledDetails insideScroll={insideScroll}/>
        </StyledProductCardSkeleton>
    );
};
